import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LeadScoringIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LeadScoring",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3.81 31.97c-.21 0-.41-.06-.59-.19-.29-.21-.44-.56-.41-.91l.47-4.5-3.03-3.36c-.24-.27-.32-.64-.21-.98s.39-.59.74-.67l4.43-.94 2.26-3.92c.36-.62 1.37-.62 1.73 0l2.26 3.92 4.43.94c.35.08.63.33.74.67s.03.71-.21.98l-3.03 3.36.47 4.5c.04.36-.12.7-.41.91s-.67.25-.99.11l-4.13-1.84-4.13 1.84c-.13.06-.27.09-.41.09Zm4.54-4.02c.14 0 .28.03.41.09l2.96 1.32-.34-3.22a1 1 0 0 1 .25-.77l2.17-2.41-3.17-.67a.99.99 0 0 1-.66-.48l-1.62-2.8-1.62 2.8c-.14.25-.38.42-.66.48l-3.17.67 2.17 2.41c.19.21.28.49.25.77l-.34 3.22 2.96-1.32c.13-.06.27-.09.41-.09"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.85 31.56a1.14 1.14 0 0 1-.23-2.26c6.34-1.3 10.95-6.95 10.95-13.44 0-7.56-6.15-13.71-13.71-13.71S2.14 8.3 2.14 15.86a1.14 1.14 0 1 1-2.28 0c0-8.83 7.17-16 16-16s16 7.18 16 16c0 7.57-5.37 14.16-12.78 15.68-.08.02-.15.02-.23.02"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21.93 22.2a1.132 1.132 0 0 1-.86-1.88 6.9 6.9 0 0 0 1.65-4.46c0-3.78-3.08-6.86-6.86-6.86a6.87 6.87 0 0 0-5.69 3.02c-.35.52-1.06.66-1.59.31-.52-.35-.66-1.06-.31-1.59a9.16 9.16 0 0 1 7.58-4.03c5.04 0 9.14 4.1 9.14 9.14 0 2.18-.78 4.29-2.2 5.95-.23.26-.55.4-.87.4Z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "15.86",
      cy: "15.86",
      r: "1.14"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.86 18.14c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29a2.29 2.29 0 1 1 0 4.58"
    })]
  }));
};
LeadScoringIcon.displayName = 'LeadScoringIcon';